import { gql } from '@apollo/client';
const REMOVE_MODEL_SPECIFICATION_FOLDER = gql `
  mutation RemoveModelSpecificationFolder($folderId: ID!) {
    removeModelSpecificationFolder(folderId: $folderId) {
      removed
    }
  }
`;
export default REMOVE_MODEL_SPECIFICATION_FOLDER;
